import React from "react";
import PropTypes from "prop-types";
import translate from "react-i18next/dist/commonjs/translate";

class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
    }
    onCancel() {
        const modal = document.querySelector(".modal")
        modal.style.display = "none";
    }
    render() {       
        const { incidentId, redirectToSupportPage} = this.props;
        
        return (
            <div className="modal">
            <div className="modal_content">
              <span className="close">&times;</span>
              <p>Incidenten ska forstättningsvis vara Öppen. Vänligen notera Incident ID i din beställning av Forensic Investigation or deeper analysis</p>
              <p>Denna incident har ID : {incidentId}</p>
              <div className="btn-toolbar" role="toolbar">
                <div className="btn-group" role="group">
                    <button type="button" onClick={this.onCancel} className="btn btn-default mr-1">Cancel</button>
                </div>
                <div className="btn-group" role="group">
                    <button type="button" onClick={redirectToSupportPage} className="btn btn-default">Confirm</button>
                </div>
              </div>
              </div>
            </div>
        );        
    }
}

Popup.propTypes = {
    incidentId: PropTypes.number.isRequired,
    redirectToSupportPage: PropTypes.func.isRequired
};

export default translate("translations")(Popup);
    
    


// WEBPACK FOOTER //
// ./src/incidents/popup.js